/**
 * Reusable Onboarding Step Component
 * Layout with optional animation/illustration, title, and description
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface OnboardingStepProps {
  title: string;
  description: string;
  illustration?: ReactNode;
  className?: string;
}

export function OnboardingStep({
  title,
  description,
  illustration,
  className,
}: OnboardingStepProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center px-5 py-4',
        className
      )}
    >
      {/* Illustration/Animation Section */}
      {illustration && (
        <div className="w-full max-w-sm mb-4 flex items-center justify-center">
          {illustration}
        </div>
      )}

      {/* Content Section */}
      <div className="text-center space-y-2 max-w-md">
        <h2 className="text-xl font-bold text-foreground">{title}</h2>
        <p className="text-muted-foreground text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}

export default OnboardingStep;
